import styled from 'styled-components';
export const Title = styled.span`
  font-size: 36px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-bottom: 14px;
  margin-top: -15px;
  display: block;
`;
interface DesktopCampaignDetailProps {
  title: string;
}
const DesktopCampaignDetail = ({ title }: DesktopCampaignDetailProps) => {
  return <Title>{title}</Title>;
};

export default DesktopCampaignDetail;
